import { type PageProps } from '@inertiajs/core';
import { createInertiaApp } from '@inertiajs/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

const name = 'JP School Guide';

type SharedProps = PageProps & {
  env?: {
    sentryDsn?: string | null;
  };
};

createInertiaApp<SharedProps>({
  title: (title) => (title ? `${title} - ${name}` : name),
  resolve: async (name) => {
    const pages = import.meta.glob('./pages/**/*.tsx', { eager: true });
    // console.log('Resolving page:', name, pages);
    return pages[`./pages/${name}.tsx`];
  },
  setup: ({ el, App, props }) => {
    const sentryDsn = props.initialPage.props.env?.sentryDsn;
    if (sentryDsn) {
      Sentry.init({
        dsn: sentryDsn,
        sendDefaultPii: true,
      });
    }
    createRoot(el).render(
      <StrictMode>
        <App {...props} />
      </StrictMode>
    );
  },
});
